export default "__VITE_ASSET__BURGxkZM__"